import { render } from "./SBtnClear.vue?vue&type=template&id=0f76b7ac&ts=true"
import script from "./SBtnClear.vue?vue&type=script&lang=ts"
export * from "./SBtnClear.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__